"use strict";

angular.module("licensure.services").factory("EXForms", [
    "$http",
    "$q",
    function($http, $q) {
        return {
            get: function() {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/GetAllExamForms", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getformCount: function (id) {
                var d = $q.defer();
                $http
                    .get(apiLocation + "/api/ExamModule/ExamFormFBCount/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getform: function(id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/EXForms/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getPacketListById: function(id) {
                var d = $q.defer();
                $http
                    .get(apiLocation + "/api/ExamModule/ExamPackets/", {
                        params: {ExamFormId: id},
                    }) 
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            updateStatus: function(ids, status) {
                var d = $q.defer();
                $http
                    .post(
                        apiLocation + "/api/ExamModule/UpdateExamFormStatuses/",
                        {
                            examFormIDs: ids,
                            status: status
                        }
                    )
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            saveFormToExam: function(examID, FormID) {
                var d = $q.defer();
                $http
                    .post(
                        apiLocation +
                            "/api/ExamModule/ExamFormsSaveForm/" +
                            examID +
                            "/" +
                            FormID,
                        {
                            params: {}
                        }
                    )
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: function(examForm) {
                var d = $q.defer();

                var method = "POST";
                var url = apiLocation + "/api/EXForms/";

                if (!isUndefined(examForm.id)) {
                    method = "PUT";
                    url += examForm.id;
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        exam_form: examForm
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function(id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + "/api/EXForms/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            copy: function(ExamFormIDInfo) {
                var d = $q.defer();
                $http
                    .post(apiLocation + "/api/exams/copyForm", {
                        copyID: ExamFormIDInfo
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        };
    }
]);
